// extracted by mini-css-extract-plugin
module.exports = {"actions":"save-search-modal-module--actions--3tHP8","buttons":"save-search-modal-module--buttons--1s-Fb"};